import React from 'react';

const ReferPatientToSpecialist = ({ 
  isOpen, 
  onClose, 
  patientId, 
  treatmentId,
  ...props 
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Refer Patient to Specialist</h2>
        <p>Feature under development</p>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default ReferPatientToSpecialist;
